// x-scroll-column-feed.js

/*
This script:
- Works alongside CSS of same name to enable horizontal scroll for frontpage feeds and events.
- Detects class "scroll-column-feed" and determines if there is horizontal overflow.
- Adds prev/next buttons and calculates distance to scroll on click.
*/

export default function xScrollColumnFeed() {

  // Stop if not frontpage
  if (document.body.id != "vrtx-frontpage") {
    return;
  }

  const scrollColumFeedsAll = document.querySelectorAll(".vrtx-frontpage-box[class*=scroll-column-feed]");

  if (!scrollColumFeedsAll.length) {
    return;
  }

  const isEnglish = document.documentElement.lang === "en";

  scrollColumFeedsAll.forEach(feed => {
    const rowHeading = feed.closest(".row").querySelector("h2");
    const feedContent = feed.querySelector(".vrtx-box-content");

    if (!feedContent) {
      console.debug("scroll-column-feed: no content");
      return;
    }
    // Check if articles or events
    const articleItems = feed.querySelectorAll('li');
    const eventItems = feed.querySelectorAll(".vrtx-event-component-item");
    let feedItems;

    if (articleItems.length) {
      feedItems = articleItems;
    }
    else if (eventItems.length) {
      feedItems = eventItems;
    }
    else {
      return; // If no items or incorrect use
    }

    // Detect if overflows or limited (fits width)
    if (feedContent.scrollWidth === feedContent.offsetWidth) {
      if (articleItems.length) {
        feed.querySelector(".items").classList.add("limited");
      }
      else if (eventItems.length) {
        feed.querySelector(".vrtx-event-component").classList.add("limited");
      }
    }
    else {
      // If overflows, set tabindex to enable scroll with arrow keys (recommened WCAG)
      feedContent.tabIndex = 0;
    }

    // If less than 2 items, won't overflow, so stop
    if (feedItems.length < 2) {
      return;
    }

    // Function to get distance between feed items
    function getItemDistance() {
      return feedItems[1].offsetLeft - feedItems[0].offsetLeft;
    }

    // Create prev/next buttons
    const prevButton = document.createElement("button");
    prevButton.className = "prev";
    prevButton.setAttribute("aria-label", isEnglish ? "Previous" : "Forrige");

    const nextButton = document.createElement("button");
    nextButton.className = "next";
    nextButton.setAttribute("aria-label", isEnglish ? "Next" : "Neste");

    // Create container for row-heading and prev/next buttons
    // Wrapper for buttons
    const buttonWrapper = document.createElement("div");
    buttonWrapper.className = "buttons";

    // Append buttons to the buttonWrapper
    buttonWrapper.append(prevButton, nextButton);

    // Create the heading-prev-next div
    const headingPrevNext = document.createElement("div");
    headingPrevNext.className = "heading-prev-next";

    // Append rowHeading if it exists
    if (rowHeading) {
      headingPrevNext.append(rowHeading);
    }

    // Append buttonWrapper to headingPrevNext
    headingPrevNext.append(buttonWrapper);

    // Insert headingPrevNext into the DOM before the 'feed' element
    feed.before(headingPrevNext);

    // Prev/next buttons click
    prevButton.addEventListener("click", () => {
      const itemDistance = getItemDistance();
      feedContent.scrollTo({
        left: feedContent.scrollLeft - itemDistance,
        behavior: "smooth"
      });
    });
    nextButton.addEventListener("click", () => {
      const itemDistance = getItemDistance();
      feedContent.scrollTo({
        left: feedContent.scrollLeft + itemDistance,
        behavior: "smooth"
      });
    });
  });

}